import type { OnboardedStackParamList } from '@navigation/OnboardedStack';
import { HomeRoute, OnboardedStackRoute, OnboardedTabRoute } from '@navigation/Routes';
import { CommonActions } from '@react-navigation/native';
import type { NavigationState, PartialState } from '@react-navigation/native';

type OnboardedStackResetState = PartialState<NavigationState<OnboardedStackParamList>>;

type DispatchNavigationAction = {
  dispatch: (action: ReturnType<typeof CommonActions.reset>) => void;
};

const HOME_WITH_RELOAD_RESET_STATE = {
  index: 0,
  routes: [
    {
      name: OnboardedStackRoute.OnboardedTab,
      params: {
        screen: OnboardedTabRoute.Home,
        params: {
          screen: HomeRoute.Home,
          params: { reload: true },
        },
      },
    },
  ],
} satisfies OnboardedStackResetState;

export function resetToHomeWithReload(navigation: DispatchNavigationAction) {
  navigation.dispatch(CommonActions.reset(HOME_WITH_RELOAD_RESET_STATE));
}
